import { ADICIONAR_FILTRO_MDFE } from '../types'

export default function adicionarFiltroMdfe(filtro) {
  return {
    type: ADICIONAR_FILTRO_MDFE,
    payload: filtro
  }
}
